import React, { Suspense } from "react";
import { Route } from "react-router-dom";

import SentryRoutes from "../SentryRoutes";
import NotFound from "../components/Pages/NotFound";
import ProfessionalRouteGuard from "./ProfessionalRouteGuard";
import RecruiterRouteGuard from "./RecruiterRouteGuard";
import RouteLoading from "./RouteLoading";
import {
  customerRouteConfig,
  professionalRouteConfig,
  recruiterRouteConfig,
} from "./routeConfig";

const ProfessionalRoutes = () => {
  return (
    // The dashboard and recruiter pages load on demand (routeConfig.js).
    <Suspense fallback={<RouteLoading />}>
      <SentryRoutes>
        {customerRouteConfig.map(({ path, component: Component }) => (
          <Route
            key={`customer-${path}`}
            path={path}
            element={<Component />}
          />
        ))}

        {professionalRouteConfig.map(({ path, component: Component, ...access }) => (
          <Route
            key={`professional-${path}`}
            path={path}
            element={
              <ProfessionalRouteGuard {...access}>
                <Component />
              </ProfessionalRouteGuard>
            }
          />
        ))}

        {recruiterRouteConfig.map(({ path, component: Component }) => (
          <Route
            key={`recruiter-${path}`}
            path={path}
            element={
              <RecruiterRouteGuard>
                <Component />
              </RecruiterRouteGuard>
            }
          />
        ))}

        {/* Keep last: a catch-all registered earlier would shadow the real routes. */}
        <Route path="*" element={<NotFound />} />
      </SentryRoutes>
    </Suspense>
  );
};

export default ProfessionalRoutes;
